import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import Button from './Button';
import { userDriveIntegrateAuthAction,
         userDriveIntegratedAction,
         userDriveIntegrationDeleteAction,
         userLogInLoadAction
} from '../../actions/userActions';

import { caseSetServerError } from '../../actions/caseActions';


export const isDriveIntegrated = user => user && ((user['GDriveAccount'] && 'GDriveToken') || (user['OneDriveAccount'] && 'OneDriveToken'));

class DriveIntegration extends PureComponent {
    constructor(props) {
        super(props);
        this.integrateAction = this.integrateAction.bind(this);
        this.state = {
            popup: false,
            loading: false,
        };
    }

    integrateAction(tokenName = undefined) {
        if (this.state.popup) {
            try {
                popup.focus();
            } catch (error) {}
        }

        if (this.props.driveIntegrated) {
            this.setState({ loading: true });
            this.props.dispatch(userDriveIntegrationDeleteAction())
                .then(() => {
                    this.setState({ loading: false });
                    this.props.dispatch(userDriveIntegratedAction(false, 'GDriveToken'));
                })
                .catch((error) => {
                    this.setState({ loading: false });
                    console.error(new Error().stack, error);
                    this.props.dispatch(caseSetServerError(error));
                });

            return;
        }

        this.props.dispatch(userDriveIntegrateAuthAction(tokenName))
            .then((result) => {
                if (!result) {
                    console.error('Drive integration failed');
                    this.props.dispatch(caseSetServerError('Drive integration failed.'));
                    return;
                }

                const popupBlockedError = () => {
                    this.props.dispatch(userDriveIntegratedAction(false, tokenName));
                    this.props.dispatch(caseSetServerError('Please allow popup windows to sign in.\nThere is typically an icon in the address bar\nwhere you can click to enable the popup.'));
                };

                switch (result.data.type) {
                case 'AUTHORIZATION':
                    const authUrl = result.data.authUrl;
                    const popup = window.open(authUrl, 'popup', 'toolbar=0,status=0,width=500,height=500');
                    if(!popup || popup.closed || typeof popup.closed == 'undefined') {
                         popupBlockedError();

                    } else {
                        this.setState({ popup });
                        try {
                            popup.focus();
                            const toastrOptions = {
                                timeOut: 15000, // by setting to 0 it will prevent the auto close
                                showCloseButton: true, // true by default
                                removeOnHover: true,
                                progressBar: true,
                            };

                            const success = () => {
                                clearInterval(timer);
                                    popup.close();
                                    this.props.dispatch(userDriveIntegratedAction(true, tokenName));
                                    toastr.success('Success', 'Drive successfully integrated', toastrOptions)
                            };

                            const error = () => {
                                clearInterval(timer);
                            };

                            let timer = setInterval(() =>
                            {
                                if (popup.closed) {
                                    this.props.dispatch(userLogInLoadAction())
                                        .then((result) => {
                                            if (!result) {
                                                error();
                                                return;
                                            }

                                            const user = result.data.user;
                                            if (user['GDriveAccount'] || user['OneDriveAccount']) {
                                                success();

                                            } else {
                                                error();
                                                return;
                                            }

                                        }).catch((error) => {
                                            error();
                                        });

                                } else {
                                    this.props.dispatch(userLogInLoadAction())
                                        .then((result) => {
                                            if (!result) {
                                                return;
                                            }

                                            const user = result.data.user;
                                            if (user['GDriveAccount'] || user['OneDriveAccount']) {
                                                success();
                                            }

                                        }).catch((error) => {
                                            console.error(new Error().stack, error);
                                        });
                                }
                            },
                            2000);

                        } catch(error) {
                            popupBlockedError();
                        }
                    }

                    break;

                case 'SUCCESS':
                    break;

                default:
                    console.error(result);
                    this.props.dispatch(caseSetServerError('Invalid drive result type!'));
                    break;
                }

            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
            });
    }


    render() {
        const loading = this.state.loading;
        const imgStyle = { height: '25px' };
        switch (this.props.driveIntegrated) {
        case 'GDriveToken':
            return (
                <Button 
                    label='Disconnect GDrive'
                    img="/img/gdrive_icon.png"
                    imgStyle={imgStyle}
                    loading={loading}
                    loadingLabel="Loading ..."
                    onClick={() => this.integrateAction('GDriveToken')}
                />
            );

        case 'OneDriveToken':
            return (
                <Button
                    label='Disconnect One Drive'
                    img="/img/onedrive_icon.png"
                    imgStyle={imgStyle}
                    loading={loading}
                    loadingLabel="Loading ..."
                    onClick={() => this.integrateAction('OneDriveToken')}
                />
            );

        default:
            return (
                <React.Fragment>
                    <Button
                        label=' GDrive'
                        disabled={loading}
                        img='/img/gdrive_icon.png'
                        imgStyle={imgStyle}
                        onClick={() => this.integrateAction('GDriveToken')}
                    />
                </React.Fragment>
            );

            // <Button 
            //     label=' One Drive'
            //     disabled={loading}
            //     img='/img/onedrive_icon.png'
            //     imgStyle={imgStyle}
            //     onClick={() => this.integrateAction('OneDriveToken')}
            // />
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    const user = state.user.loggedIn;
    const driveIntegrated = isDriveIntegrated(user);
    const props = {
        user,
        driveIntegrated,
    };

    return props;
};


export default connect(mapStateToProps)(DriveIntegration);
